import React from "react";
import { CardWithRelations } from "@/hooks/useCards";
import { CardVariantWithBinder } from "@/types/varinats";
import { CardVariantItem } from "./CardVariantItem";

export interface CardDetailsModalVariantsProps {
  card: CardWithRelations | null;
  variants: CardVariantWithBinder[];
  scanning?: boolean;
}

const CardDetailsModalVariants: React.FC<CardDetailsModalVariantsProps> = ({
  card,
  variants,
  scanning = false,
}) => {
  const titleText = `All Variants (${variants.length})`;
  const subtitleText = "Available variants for this card";

  if (!card) {
    return null;
  }

  return (
    <div className="mt-6 grid gap-4">
      <div>
        <h3 className="text-lg font-semibold">{titleText}</h3>
        <p className="text-sm text-muted-foreground">{subtitleText}</p>
      </div>
      <div>
        <div className="space-y-3">
          {variants.map((variant) => {
            return (
              <CardVariantItem
                card={card}
                key={variant.id}
                variant={variant}
                scanning={scanning}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CardDetailsModalVariants;
